<template>
  <div>
    <v-row class="primary py-4">
      <v-col cols="12" align="center" style="height: 250px">
        <br />
        <br />
        <p class="display-1 white--text">Ingin Bertanya?</p>
        <p class="headline white--text">Artikel Rangkuman dari Pertanyaan yang Sering Ditanyakan</p>
      </v-col>
    </v-row>
    <v-row v-for="(faq, i) in faqs" :key="faq.index">
      <span class="title font-weight-bold py-2 my-2">{{ faq[0].bab }}</span>
      <template v-if="i == 0">
        <v-expansion-panels v-model="items1" accordion flat>
          <v-expansion-panel class="pt-2" v-for="(item, index) in faq" :key="item.index">
            <v-expansion-panel-header class="title py-0">
              <template v-slot:actions>
                <v-icon color="primary"> mdi-chevron-down-circle </v-icon>
              </template>
              <v-row no-gutters>
                <v-col class="shrink">{{ index + 1 }}. &nbsp;</v-col>
                <v-col class="grow">&nbsp;{{ item.judul }}</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="blue lighten-5 pt-4">
              <div v-html="item.konten"></div>
              <div>
                <v-icon small>mdi-eye</v-icon><span class="caption"> &nbsp;Dilihat : {{ faq[index].jumlah }}</span>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-if="i == 1">
        <v-expansion-panels v-model="items2" accordion flat>
          <v-expansion-panel class="pt-2" v-for="(item, index) in faq" :key="item.index">
            <v-expansion-panel-header class="title">
              <template v-slot:actions>
                <v-icon color="primary"> mdi-chevron-down-circle </v-icon>
              </template>
              <v-row no-gutters>
                <v-col class="shrink">{{ index + 1 }}. &nbsp;</v-col>
                <v-col class="grow">{{ item.judul }}</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="blue lighten-5 pt-4">
              <div v-html="item.konten"></div>
              <div>
                <v-icon small>mdi-eye</v-icon><span class="caption"> &nbsp;Dilihat : {{ faq[index].jumlah }}</span>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-if="i == 2">
        <v-expansion-panels v-model="items3" accordion flat>
          <v-expansion-panel class="pt-2" v-for="(item, index) in faq" :key="item.index">
            <v-expansion-panel-header class="title">
              <template v-slot:actions>
                <v-icon color="primary"> mdi-chevron-down-circle </v-icon>
              </template>
              <v-row no-gutters>
                <v-col class="shrink">{{ index + 1 }}. &nbsp;</v-col>
                <v-col class="grow">{{ item.judul }}</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="blue lighten-5 pt-4">
              <div v-html="item.konten"></div>
              <div>
                <v-icon small>mdi-eye</v-icon><span class="caption"> &nbsp;Dilihat : {{ faq[index].jumlah }}</span>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-row>
    <br />
  </div>
</template>

<script>
import { FAQ_REGISTRASI } from "../faq.js";
export default {
  name: "home-faq",
  components: {},
  data() {
    return {
      faqs: [],
      items1: null,
      items2: null,
      items3: null,
    };
  },
  mounted() {
    this.findFaq();
  },
  methods: {
    // @vuese
    // mengirimkan index dan key yang di hit user untuk perhitungan jumlah hit
    // @arg index FAQ dan key FAQ
    sendCounter(index, key) {
      return this.$store
        .dispatch("user/setCounter", {
          instansi_id: this.instansi_id,
          key: key,
          obj: { progress: false },
        })
        .catch((e) => e);
    },
    // @vuese
    // pencarian FAQ berdasarkan instansi id yang tersedia
    findFaq() {
      if (this.instansi_id == 1) {
        this.faqs = FAQ_REGISTRASI;
      } else {
        this.faqs = [];
      }
    },
  },

  watch: {
    // @vuese
    // penentuan FAQ berdasarkan instansi id yang tersedia
    instansi_id(n) {
      if (n == 1) {
        this.faqs = FAQ_REGISTRASI;
      } else {
        this.faqs = [];
      }
    },
    // @vuese
    // cek perubahan expand dengan v-model items1 (send saat expand pertama dibuka dan tutup expand item lain)
    items1(n) {
      if (typeof n == "undefined") return;

      this.sendCounter(n, this.faqs[0][n].key).then((res) => {
        this.faqs[0][n].jumlah = res.jumlah;
        this.items2 = undefined;
        this.items3 = undefined;
      });
    },
    // @vuese
    // cek perubahan expand dengan v-model items2 (send saat expand pertama dibuka dan tutup expand item lain)
    items2(n) {
      if (typeof n == "undefined") return;

      this.sendCounter(n, this.faqs[1][n].key).then((res) => {
        this.faqs[1][n].jumlah = res.jumlah;
        this.items1 = undefined;
        this.items3 = undefined;
      });
    },
    // @vuese
    // cek perubahan expand dengan v-model items3 (send saat expand pertama dibuka dan tutup expand item lain)
    items3(n) {
      if (typeof n == "undefined") return;

      this.sendCounter(n, this.faqs[2][n].key).then((res) => {
        this.faqs[2][n].jumlah = res.jumlah;
        this.items1 = undefined;
        this.items2 = undefined;
      });
    },
  },
};
</script>
